import React, { useState, useEffect, useMemo } from "react";
import {
  Button,
  Card,
  Container,
  Form,
  Row,
  Col,
  Spinner,
  Modal,
} from "react-bootstrap";
import Swal from "sweetalert2";
import { Dropdown } from "react-bootstrap";


import {API_BASE} from "../../services/apirest";

const BODEGA_ROLES = [9, 12];

export default function SolicitudForm() {
  const today = useMemo(() => new Date().toISOString().slice(0, 10), []);

  const [form, setForm] = useState({
    usuario: "",
    rfc: "",
    nombre_usuario: "",
    apellido_paterno: "",
    apellido_materno: "",
    telefono: "",
    fecha: today,
    foto: null,
    distribuidor: null,
    distribuidor_id: "",
    gerente: null,
    plaza_id: "",
    gerente_id: "",
    region: null,
    region_id: "",
    rol_id: "",
    estado: "Pendiente",
    uso_clave_id: "",
    ine:"",
    supervisor_distribuidor: "",
    rfc_supervisor_distribuidor: "",
    bodega_id: "", 
    clave_supervisor: ""
  });
  const [errors, setErrors] = useState({ rfc: ""}); // errores de duplicados
  const [loading, setLoading] = useState(false);
  const [currentDistribuidor, setCurrentDistribuidor] = useState(null);
  const [plazaSearch, setPlazaSearch] = useState("");
  const [showPlazaDropdown, setShowPlazaDropdown] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [isBlacklisted, setIsBlacklisted] = useState(false);
  const [showBlacklistModal, setShowBlacklistModal] = useState(false);
  const [formKey, setFormKey] = useState(0);
  const [bodegas, setBodegas] = useState([]);
  const [bodegasLoading, setBodegasLoading] = useState(false);
  const [bodegaSearch, setBodegaSearch] = useState("");
  
  const [showBodegaDropdown, setShowBodegaDropdown] = useState(false);
  const validarRFCsinHomoclave = (rfc) => {
    const regex = /^[A-ZÑ&]{3,4}\d{6}$/i;
    return regex.test(rfc);
  };
  const [isRFCDuplicate, setIsRFCDuplicate] = useState(false);
  const getVal = (obj, keys) =>
  keys.map(k => obj?.[k]).find(v => typeof v === "string" && v.trim() !== "");


const fetchData = async (endpoint, setter) => {
  try {
    const res = await fetch(`${API_BASE}/${endpoint}`, {
      headers: { 
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
    const txt = await res.text();
    if (!res.ok) throw new Error(`HTTP ${res.status} ${endpoint}\n${txt.slice(0,200)}`);
    let data;
    try { data = JSON.parse(txt); }
    catch { 
      console.error('NO JSON desde', endpoint, '→', txt.slice(0,200));
      throw new Error('Respuesta no es JSON'); 
    }
    if (data.status === "success" || data.status === "ok") {
      const result = data.result;
      // Si result es un array directamente, lo usamos
      if (Array.isArray(result)) {
        setter(result);
      } else {
        // Si es un objeto, tomamos la primera llave (ej: result.roles)
        const key = Object.keys(result)[0];
        setter(result[key] || []);
      }
    }
  } catch (err) {
    console.error(`Error fetching ${endpoint}:`, err);
  }
};


  const getBodegaParts = (b) => {
  const bodega = getVal(b, ["BODEGA","bodega"]);
  const almacen = getVal(b, ["ALMACEN","almacen"]);
  const region = getVal(b, ["REGION","region"]);
  const direccion = getVal(b, ["DIRECCION","direccion"]);
  return { bodega, almacen, region, direccion };
};

const bodegaFullLabel = (b) => {
  const { bodega, almacen, region } = getBodegaParts(b);
  return [bodega, almacen, region].filter(Boolean).join(" — ");
};

  const [, setCorreoDistribuidor] = useState("");
  const [distribuidores, setDistribuidores] = useState([]);
  const [gerentes, setGerentes] = useState([]);
  const [regiones, setRegiones] = useState([]);
  const [roles, setRoles] = useState([]);
  const [usosClave, setUsosClave] = useState([]);

  useEffect(() => { fetchData(`distribuidores.php`, setDistribuidores); }, []);
  useEffect(() => { fetchData(`gerentes.php`, setGerentes); }, []);
  useEffect(() => { fetchData(`region.php`, setRegiones); }, []);
  useEffect(() => { fetchData(`admin_db.php?table=roles&pk=id`, setRoles); }, []);
  useEffect(() => { fetchData(`admin_db.php?table=uso_clave&pk=id`, setUsosClave); }, []);

  const resetAll = () => {
  // Limpia el formulario completo
  setForm({
    usuario: "",
    rfc: "",
    nombre_usuario: "",
    apellido_paterno: "",
    apellido_materno: "",
    telefono: "",
    fecha: today,
    foto: null,
    distribuidor: null,
    distribuidor_id: "",
    gerente: null,
    plaza_id: "",
    gerente_id: "",
    region: null,
    region_id: "",
    rol_id: "",
    estado: "Pendiente",
    uso_clave_id: "",
    ine: null,
    supervisor_distribuidor: "",
    rfc_supervisor_distribuidor: "",
    bodega_id: "",
    clave_supervisor: ""
  });

  // Limpia errores y flags
  setErrors({ rfc: "", rfc_supervisor_distribuidor: "" });
  setIsRFCDuplicate(false);
  setIsBlacklisted(false);
  setPlazaSearch("");
  setShowPlazaDropdown(false);
  setShowPlazaDropdown(false);

  // Cierra modales
  setShowDetailModal(false);
  setShowBlacklistModal(false);

  // Remonta el <Form> para limpiar file input
  setFormKey(k => k + 1);
};

  const resetFields = {
    usuario: "",
    rfc: "",
    nombre_usuario: "",
    apellido_paterno: "",
    apellido_materno: "",
    telefono: "",
    fecha: today,
    foto: null,
    rol_id: "",
    estado: "Pendiente",
    uso_clave_id: "",
    ine: null,
    plaza_id: "",
    gerente: null,
    gerente_id: "",
    region: null,
    region_id: "",
    bodega_id: "",
    supervisor_distribuidor: "",
    rfc_supervisor_distribuidor: "",
    clave_supervisor: ""
  };


  

  const sortedPlazas = useMemo(
      () => regiones.slice().sort((a,b)=>a.plaza.localeCompare(b.plaza)),
      [regiones]
  );


  useEffect(() => {
    if (distribuidores.length === 0) {
      return; // Esperamos a que distribuidores se llene
    }

    const fetchPerfil = async () => {
      try {
        const res = await fetch(`${API_BASE}/perfil.php`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,

          },
        });
        const { status, result } = await res.json();
        if (status === "success" && result.user) {
          const distId = result.user.distribuidor_id;
          // Buscamos el objeto completo en la lista de distribuidores
          const distObj = distribuidores.find(
              (d) => String(d.id_distribuidor) === String(distId)
          );
          if (distObj) {
            setCurrentDistribuidor(distObj);
            // Preseleccionamos ese distribuidor en el formulario
            setForm((prev) => ({
              ...prev,
              distribuidor: distObj,
              distribuidor_id: String(distId),
            }));
          }
        }
      } catch (err) {
        console.error("Error al obtener perfil:", err);
      }
    };

    fetchPerfil();
  }, [distribuidores]);



  // función para chequear duplicados
 const checkDuplicate = async (field, value) => {
  const val = value.trim();
  if (!val) {
    setErrors(prev => ({ ...prev, [field]: "" }));
    if (field === "rfc") setIsRFCDuplicate(false);
    return;
  }

  try {
    // 1) Chequeo en tu endpoint de duplicados
    const resChk = await fetch(
      `${API_BASE}/checkRegistro.php?campo=${field}&valor=${encodeURIComponent(val)}`
    );
    const chk = await resChk.json();

    if (field === "rfc") {
      // Si viene OK y un result con status Activo
      if (
        chk.status === "ok" &&
        Array.isArray(chk.result) &&
        chk.result[0]?.status === "Activo"
      ) {
        // RFC ya activo → bloqueamos el envío y mostramos modal
        setIsRFCDuplicate(true);
        setShowDetailModal(true);
        setErrors(prev => ({ ...prev, rfc: "" }));
        return;
      } 
      // En cualquier otro caso, permitimos enviar
      setIsRFCDuplicate(false);
    }

    // Validación genérica de error_msg si existe
    setErrors(prev => ({
      ...prev,
      [field]: chk.status !== "ok" && chk.result?.error_msg
        ? chk.result.error_msg
        : ""
    }));

  } catch (err) {
    console.error("Error en checkDuplicate:", err);
  }
};

const checkBlacklistByName = async () => {
  const fullName = `${form.nombre_usuario} ${form.apellido_paterno} ${form.apellido_materno}`.trim();
  if (!fullName) return;

  try {
    const res = await fetch(
      `${API_BASE}/blackList.php?nombre=${encodeURIComponent(fullName)}`,
    );
    const data = await res.json();
    if (data.status === "ok" && Array.isArray(data.result) && data.result.length > 0) {
      setIsBlacklisted(true);
      setShowBlacklistModal(true);
    } else {
      setIsBlacklisted(false);
    }
  } catch (err) {
    console.error("Error buscando en blacklist:", err);
    setIsBlacklisted(false);
  }
};
useEffect(() => {
  const rol = Number(form.rol_id);
  if (!BODEGA_ROLES.includes(rol) || !form.distribuidor_id) {
    setBodegas([]);
    setForm(prev => ({ ...prev, bodega_id: "" }));
    return;
  }

  (async () => {
    try {
      setBodegasLoading(true);
      const res = await fetch(
        `${API_BASE}/bodegas.php?distribuidor_id=${form.distribuidor_id}`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
      );
      const json = await res.json();
      const arr = json?.result?.bodegas || [];
      setBodegas(arr);
    } catch (e) {
      console.error("Error cargando bodegas:", e);
      setBodegas([]);
    } finally {
      setBodegasLoading(false);
    }
  })();
}, [form.rol_id, form.distribuidor_id]);

const sortedBodegas = useMemo(() => {
  return [...bodegas].sort((a, b) => {
    const AREG = (a.REGION || a.region || "").localeCompare(b.REGION || b.region || "");
    if (AREG !== 0) return AREG;
    const ACOD = (a.BODEGA || a.bodega || a.ALMACEN || a.almacen || "")
      .localeCompare(b.BODEGA || b.bodega || b.ALMACEN || b.almacen || "");
    return ACOD;
  });
}, [bodegas]);

const selectedBodega = useMemo(
  () => bodegas.find(b => String(b.id_bodega) === String(form.bodega_id)),
  [bodegas, form.bodega_id]
);



 const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      for (const key in form) {
        if (key === "ine" && form.ine instanceof File) {
          formData.append("ine", form.ine);
        } else {
          formData.append(key, form[key]);
        }
      }

      const res = await fetch(`${API_BASE}/solicitudes.php`, {
        method: "POST",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        body: formData,
      });
      const data = await res.json();

      if (data.status === "success" || data.status === "ok") {
        Swal.fire("!LISTO¡", "Solicitud enviada con INE", "success");

        // Reseteamos sólo los campos de resetFields, conservando distribuidor
        setForm(prev => ({
          distribuidor: prev.distribuidor,
          distribuidor_id: prev.distribuidor_id,
          ...resetFields
        }));
        setCorreoDistribuidor(prev => prev); // mantiene correo actual
      } else {
        throw new Error(data.result.error_msg || "Error desconocido");
      }
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  

  return (
      <div className="app-container">
        <Container className="d-flex justify-content-center align-items-center" >
          <Card style={{ width: "100%", maxWidth: "620px" }} className="shadow-sm">

            {currentDistribuidor ? (
                <Card.Header style={{ backgroundColor: "#28d2ca", color: "#fff" }}>
                  <div className="d-flex flex-column">
                    <small>Registrando para:</small>
                    <strong>
                      {currentDistribuidor.distribuidores}{" "}

                    </strong>
                  </div>
                </Card.Header>
            ) : (
                <Card.Header style={{ backgroundColor: "#343a40", color: "#fff" }}>
                  <div className="d-flex flex-column">
                    <small>Distribuidor no disponible</small>
                  </div>
                </Card.Header>
            )}
            <Card.Header style={{ backgroundColor: "#d90e75", color: "#fff" }}>
              <h4 className="mb-0">Registro de Solicitud</h4>
            </Card.Header>
            <Card.Body>
              <Form  key={formKey}  onSubmit={handleSubmit}>
                {/* Fecha de envío */}
                <Form.Group className="mb-3">
                  <Form.Label>Fecha de envío</Form.Label>
                  <Form.Control type="date" value={form.fecha} readOnly />
                </Form.Group>



                {/* 3) Select de PLAZA */}
                <Form.Group className="mb-3">
                  <Form.Label>Plaza</Form.Label>
                  <Dropdown show={showPlazaDropdown} onToggle={(isOpen) => setShowPlazaDropdown(isOpen)}>
                    <Dropdown.Toggle
                        variant="outline-secondary"
                        className="w-100 text-start"
                        id="dropdown-custom"
                    >
                      {form.region?.plaza || "Seleccione plaza..."}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: "300px", overflowY: "auto" }}>
                      <Form.Control
                          autoFocus
                          type="text"
                          placeholder="Buscar plaza..."
                          value={plazaSearch}
                          onChange={(e) => setPlazaSearch(e.target.value)}
                          className="mb-2"
                      />
                      {sortedPlazas
                          .filter((p) =>
                              p.plaza.toLowerCase().includes(plazaSearch.toLowerCase())
                          )
                          .map((p) => (
                              <Dropdown.Item
                                  key={p.id}
                                  onClick={() => {
                                    const rg = regiones.find((r) => r.id === p.id);
                                    const gr = gerentes.find((g) => g.plaza_id === p.id);

                                    if (!gr) {
                                      Swal.fire({
                                        icon: "warning",
                                        title: "Sin supervisor",
                                        text: "No hay supervisor asignado a esta plaza.",
                                      });
                                    }

                                    setForm((prev) => ({
                                      ...prev,
                                      plaza_id: p.id,
                                      region: rg || null,
                                      region_id: p.id,
                                      gerente: gr || null,
                                      gerente_id: gr ? gr.id_gerente : "",
                                    }));
                                    setShowPlazaDropdown(false);
                                  }}
                              >
                                {p.plaza}
                              </Dropdown.Item>
                          ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Tipo de usuario</Form.Label>
                  <Form.Select
                      value={form.rol_id}
                      onChange={(e) =>
                          setForm((prev) => ({ ...prev, rol_id: e.target.value }))
                      }
                      required
                  >
                    <option value="">Seleccione rol</option>
                    {roles
                      .filter(r => [8, 9, 10, 11, 12].includes(Number(r.id)))
                      .map((r) => (
                        <option key={r.id} value={r.id}>
                          {r.nombre}
                        </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                {/* 4) Select de BODEGA (solo roles 9 y 13) */}
                  {BODEGA_ROLES.includes(Number(form.rol_id)) && (
                    <Form.Group className="mb-3">
                      <Form.Label>Bodega</Form.Label>

                      <Dropdown
                        show={showBodegaDropdown}
                        onToggle={(isOpen) => setShowBodegaDropdown(isOpen)}
                      >
                      <Dropdown.Toggle
                          variant="outline-secondary"
                          className="w-100 text-start"
                          id="dropdown-bodega"
                          disabled={bodegasLoading}
                        >
                          {selectedBodega
                            ? bodegaFullLabel(selectedBodega)
                            : (bodegasLoading ? "Cargando bodegas..." : "Seleccione bodega...")}
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="w-100 p-2" style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <Form.Control
                            autoFocus
                            type="text"
                            placeholder="Buscar bodega..."
                            value={bodegaSearch}
                            onChange={(e) => setBodegaSearch(e.target.value)}
                            className="mb-2"
                          />

                      {sortedBodegas
                        .filter(b => {
                          const { bodega, almacen, region, direccion } = getBodegaParts(b);
                          const haystack = `${bodega||""} ${almacen||""} ${region||""} ${direccion||""}`.toLowerCase();
                          return haystack.includes(bodegaSearch.toLowerCase());
                        })
                        .map(b => {
                          const { bodega, almacen, region } = getBodegaParts(b);
                          return (
                            <Dropdown.Item
                              key={b.id_bodega}
                              onClick={() => {
                                setForm(prev => ({ ...prev, bodega_id: String(b.id_bodega) }));
                                setShowBodegaDropdown(false);
                              }}
                            >
                              <div className="fw-semibold">{bodega || "(Sin nombre de bodega)"}</div>
                              <div className="small text-muted">
                                {almacen ? `Almacén: ${almacen}` : "Almacén: —"}
                                {region ? ` · Región: ${region}` : " · Región: —"}
                              </div>
                            </Dropdown.Item>
                          );
                        })
                      }


                          {!bodegasLoading && sortedBodegas.length === 0 && (
                            <div className="text-center text-muted p-2">Sin resultados</div>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>

                      {selectedBodega && (
                        <Form.Text className="text-muted">
                          {selectedBodega.DIRECCION || selectedBodega.direccion || ""}
                        </Form.Text>
                      )}
                    </Form.Group>
                  )}


                {/* Nombres y Apellidos */}
                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Label>Nombre(s)</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Nombre(s)"
                        value={form.nombre_usuario}
                        onChange={(e) => {
                          const value = e.target.value.toUpperCase();
                          setForm((prev) => ({ ...prev, nombre_usuario: value }));
                        }}
                        style={{ textTransform: "uppercase" }}
                        required
                    />
                  </Col>

                  <Col md={4}>
                    <Form.Label>Apellido Paterno</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Apellido Paterno"
                        value={form.apellido_paterno}
                        onChange={(e) => {
                          const value = e.target.value.toUpperCase();
                          setForm((prev) => ({ ...prev, apellido_paterno: value }));
                        }}
                        style={{ textTransform: "uppercase" }}
                        required
                    />
                  </Col>

                  <Col md={4}>
                    <Form.Label>Apellido Materno</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Apellido Materno"
                      value={form.apellido_materno}
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase();
                        setForm((prev) => ({ ...prev, apellido_materno: value }));
                      }}
                      onBlur={checkBlacklistByName}
                      style={{ textTransform: "uppercase" }}
                      required
                    />
                  </Col>

                </Row>


                {/* RFC */}
                <Form.Group className="mb-3">
                  <Form.Label>RFC (SIN HOMOCLAVE)</Form.Label>
                  <Form.Control
                      type="text"
                      placeholder="Ej. ABCM900101"
                      value={form.rfc}
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase();
                        setForm((prev) => ({ ...prev, rfc: value }));

                        // Validación en vivo sin homoclave
                        if (value && !validarRFCsinHomoclave(value)) {
                          setErrors((prev) => ({
                            ...prev,
                            rfc: "Formato incorrecto: deben ser 3 o 4 letras seguidas de 6 dígitos",
                          }));
                        } else {
                          setErrors((prev) => ({ ...prev, rfc: "" }));
                        }
                      }}
                       onBlur={e => checkDuplicate("rfc", e.target.value)}
                       isInvalid={!!errors.rfc}
                      required
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.rfc}
                  </Form.Control.Feedback>
                </Form.Group>


                <Form.Group className="mb-3">
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                      type="tel"
                      placeholder="Ej. 5512345678"
                      value={form.telefono}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // elimina letras y símbolos
                        if (value.length <= 10) {
                          setForm((prev) => ({ ...prev, telefono: value }));
                        }
                      }}
                      required
                  />
                  <Form.Text className="text-muted">
                    Solo 10 dígitos sin espacios ni guiones.
                  </Form.Text>
                </Form.Group>


                {/* Email */}
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                      type="email"
                      placeholder="usuario@ejemplo.com"
                      value={form.usuario}
                      onChange={e => setForm(prev => ({ ...prev, usuario: e.target.value }))}
                      required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Uso de clave</Form.Label>
                  <Form.Select
                      value={form.uso_clave_id}
                      onChange={(e) =>
                          setForm((prev) => ({ ...prev, uso_clave_id: e.target.value }))
                      }
                      required
                  >
                    <option value="">Seleccione tipo de uso</option>
                    {usosClave.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.clave || item.nombre}
                        </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                {/* Supervisor Distribuidor */}
                <Form.Group className="mb-3">
                  <Form.Label>Supervisor Distribuidor</Form.Label>
                  <Form.Control
                      type="text"
                      placeholder="Supervisor Distribuidor"
                      value={form.supervisor_distribuidor}
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase();
                        setForm((prev) => ({ ...prev, supervisor_distribuidor: value }));
                      }}
                      style={{ textTransform: "uppercase" }}
                  />
                </Form.Group>


                {/* RFC Supervisor Distribuidor */}
                <Form.Group className="mb-3">
                  <Form.Label>RFC Supervisor Distribuidor</Form.Label>
                  <Form.Control
                      type="text"
                      placeholder="RFC Supervisor Distribuidor"
                      value={form.rfc_supervisor_distribuidor}
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase();
                        setForm((prev) => ({ ...prev, rfc_supervisor_distribuidor: value }));

                        if (value && !validarRFCsinHomoclave(value)) {
                          setErrors((prev) => ({
                            ...prev,
                            rfc_supervisor_distribuidor: "RFC sin homoclave inválido (Ej: ABCM900101)",
                          }));
                        } else {
                          setErrors((prev) => ({
                            ...prev,
                            rfc_supervisor_distribuidor: "",
                          }));
                        }
                      }}
                      isInvalid={!!errors.rfc_supervisor_distribuidor}
                      style={{ textTransform: "uppercase" }}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.rfc_supervisor_distribuidor}
                  </Form.Control.Feedback>
                </Form.Group>

                {/* Clave Supervisor */}
                <Form.Group className="mb-3">
                  <Form.Label>CVVEN Supervisor</Form.Label>
                  <Form.Control
                      type="text"
                      placeholder="CVVEN Supervisor"
                      value={form.clave_supervisor}
                      onChange={(e) =>{
                        const value = e.target.value.toUpperCase();
                        setForm((prev) => ({ ...prev, clave_supervisor: e.target.value }));
                      }}
                      style={{ textTransform: "uppercase" }}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <Form.Label>Supervisor Interno</Form.Label>
                  <Form.Control
                      type="text"
                      readOnly
                      value={form.gerente?.supervisor_interno || ""}
                      style={{ backgroundColor: "#e9ecef", color: "#6c757d", borderColor: "#ced4da" }}
                  />
                  <Form.Text className="text-muted">
                    Gerente: {form.gerente?.gerente_interno || "—"}
                  </Form.Text>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Foto INE</Form.Label>
                  <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                          setForm((prev) => ({ ...prev, ine: e.target.files[0] }))
                      }
                      required
                  />
                </Form.Group>

                <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    disabled={loading || isRFCDuplicate || isBlacklisted}
                    style={{ backgroundColor: "#d90e75", borderColor: "#d90e75" }}
                >
                  {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Enviando...
                      </>
                  ) : (
                      "Enviar Solicitud"
                  )}
                </Button>
              </Form>
            </Card.Body>
          </Card>
        <Modal
          show={showDetailModal}
          onHide={() => setShowDetailModal(false)}
          size="lg"
          centered
          dialogClassName="modal-100w"
          style={{ zIndex: 11000 }}
        >
          <Modal.Header closeButton>
            <Modal.Title>RFC Registrado</Modal.Title>
          </Modal.Header>

          <Modal.Body className="text-center">
            <p>
              <strong>Asesor ya se encuentra registrado,</strong><br/>
              por favor revisa con tu supervisor de territorio.
            </p>
          </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                size="sm"
                onClick={resetAll}
              >
                Aceptar
              </Button>
            </Modal.Footer>
        </Modal>

        <Modal
          show={showBlacklistModal}
          onHide={() => setShowBlacklistModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Acceso Denegado</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <p>
              <strong>Este asesor se encuentra en la lista negra.<br/>
              Por favor revisa con tu supervisor de territorio.</strong>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={resetAll}>
              Aceptar
            </Button>
          </Modal.Footer>
        </Modal>


        </Container>
      </div>
  );
}